// extracted by mini-css-extract-plugin
export default {"Header":"TopUsersCard_Header__PRmHB","Name":"TopUsersCard_Name__4+e56","Title":"TopUsersCard_Title__Z-bPV","WrapHeader":"TopUsersCard_WrapHeader__LzsOp"};